import { styled, css, Box, darken } from '@mui/material'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/opacity.css'
import { getUnitValue } from '../../../utils/processStyles'
import {
  ImageInternalProps,
  ImageStylesProps,
  IIMageDefault
} from './Image.types'

export const ImageWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['cover', 'elemWidth'].includes(String(prop))
})<ImageStylesProps & ImageInternalProps>(
  ({ theme, ratio = 100, radius, cover, size, elemWidth = 100 }) => css`
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${getUnitValue(size)};
    max-width: 100%;
    height: ${(ratio * elemWidth) / 100}px;
    border-radius: ${getUnitValue(radius)};
    background-color: ${theme.palette?.background?.paper};

    img {
      object-fit: ${cover ? 'cover' : 'contain'};
    }

    .lazy-load-image-background {
      width: 100%;
      height: 100%;
    }

    .lazy-load-image-loaded + svg {
      opacity: 0;
    }
  `
)
ImageWrapper.defaultProps = {
  ratio: 100,
  size: '100%',
  radius: 0,
  cover: false
}

export const ImageLazy = styled(LazyLoadImage)(
  () => css`
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `
)
ImageLazy.defaultProps = {
  effect: 'opacity'
}

export const ImagePlaceholder = styled(Box)(
  ({ theme }) => css`
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${darken(theme.palette.background.default, 0.015)};
    opacity: 1;
    transition: opacity 0.3s;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    svg {
      opacity: 0.75;
      font-size: 24px;
      color: ${theme.palette?.text?.disabled};
    }

    .lazy-load-image-loaded + & {
      opacity: 0;
    }
  `
)

export const ImageDefault = styled('img')<IIMageDefault>(
  ({ hasError = false }) => css`
    display: ${hasError ? 'none' : 'initial'};
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `
)
